import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { ReactComponent as SettingsIcon } from '../icons/settings.svg';
import ApiService from '../api_services/apiService.jsx';
import './SettingsModal.css';

const SettingsModal = ({ onClose }) => {
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!oldPassword || !newPassword || !repeatPassword) {
            alert('Uzupełnij wszystkie pola hasła.');
            return;
        }

        if (newPassword !== repeatPassword) {
            alert('Nowe hasło i powtórzone hasło muszą być takie same.');
            return;
        }

        setIsSaving(true);
        try {
            await ApiService.changePasswordWithOldPassword(oldPassword, newPassword);
            alert('Hasło zostało zmienione.');
            onClose();
        } catch (error) {
            console.error('Błąd zmiany hasła:', error);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="settings-edit-overlay" onClick={onClose}>
            <div className="settings-edit-panel" onClick={(e) => e.stopPropagation()}>
                <div className="settings-edit-header">
                    <h2 className="settings-edit-title">
                        <SettingsIcon className="settings-edit-title-icon" />
                        Zmień hasło
                    </h2>
                    <button className="settings-edit-close" type="button" onClick={onClose}>&times;</button>
                </div>

                <p className="settings-edit-subtitle">Ustaw nowe hasło do konta organizatora</p>

                <form className="settings-edit-form" onSubmit={handleSubmit}>
                    <div className="settings-edit-group">
                        <label htmlFor="oldPassword">Stare hasło</label>
                        <div className="settings-password-wrap">
                            <input
                                id="oldPassword"
                                type={showOldPassword ? 'text' : 'password'}
                                placeholder="************"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                                autoComplete="current-password"
                            />
                            <button
                                className="settings-password-toggle"
                                type="button"
                                onClick={() => setShowOldPassword((prev) => !prev)}
                                aria-label={showOldPassword ? 'Ukryj hasło' : 'Pokaż hasło'}
                                title={showOldPassword ? 'Ukryj hasło' : 'Pokaż hasło'}
                            >
                                {showOldPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                            </button>
                        </div>
                    </div>

                    <div className="settings-edit-group">
                        <label htmlFor="newPassword">Nowe hasło</label>
                        <div className="settings-password-wrap">
                            <input
                                id="newPassword"
                                type={showNewPassword ? 'text' : 'password'}
                                placeholder="************"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                autoComplete="new-password"
                            />
                            <button
                                className="settings-password-toggle"
                                type="button"
                                onClick={() => setShowNewPassword((prev) => !prev)}
                                aria-label={showNewPassword ? 'Ukryj hasło' : 'Pokaż hasło'}
                                title={showNewPassword ? 'Ukryj hasło' : 'Pokaż hasło'}
                            >
                                {showNewPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                            </button>
                        </div>
                    </div>

                    <div className="settings-edit-group">
                        <label htmlFor="repeatPassword">Powtórz nowe hasło</label>
                        <div className="settings-password-wrap">
                            <input
                                id="repeatPassword"
                                type={showRepeatPassword ? 'text' : 'password'}
                                placeholder="************"
                                value={repeatPassword}
                                onChange={(e) => setRepeatPassword(e.target.value)}
                                autoComplete="new-password"
                            />
                            <button
                                className="settings-password-toggle"
                                type="button"
                                onClick={() => setShowRepeatPassword((prev) => !prev)}
                                aria-label={showRepeatPassword ? 'Ukryj hasło' : 'Pokaż hasło'}
                                title={showRepeatPassword ? 'Ukryj hasło' : 'Pokaż hasło'}
                            >
                                {showRepeatPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                            </button>
                        </div>
                    </div>

                    <div className="settings-edit-actions">
                        <button className="settings-edit-btn-light" type="button" onClick={onClose} disabled={isSaving}>Anuluj</button>
                        <button className="settings-edit-btn-primary" type="submit" disabled={isSaving}>
                            {isSaving ? 'Zapisywanie...' : 'Zapisz zmiany'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SettingsModal;
